import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import EvaluationProcess from "@/components/EvaluationProcess";
import WhyOFunded from "@/components/WhyOFunded";
import Payouts from "@/components/Payouts";
import CTABanner from "@/components/CTABanner";
import { PageBreadcrumb, RelatedLinks } from "@/components/SEOBlocks";

const HOW_RELATED = [
  { to: "/challenges",       label: "Browse Challenges",   tagline: "Instant, 1-Step & 2-Step" },
  { to: "/general-rules",    label: "Trading Rules",       tagline: "Drawdown, targets & payouts" },
  { to: "/calculator",       label: "Profit Calculator",   tagline: "Project your monthly payout" },
  { to: "/platforms/compare",label: "Compare Platforms",   tagline: "Pick your venue" },
];

export default function HowItWorksFullPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="page-how-it-works-full" className="relative overflow-x-hidden">
      <Navbar />
      <main className="pt-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-6 mb-10">
          <PageBreadcrumb items={[{ label: t("howItWorks.breadcrumb", "How It Works") }]} />
          <div className="pill-mono inline-flex mb-4">{t("howItWorks.pill", "How It Works")}</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight mb-3">
            {t("howItWorks.titlePart1", "From challenge to first payout —")}{" "}
            <span className="text-gradient-brand font-semibold">{t("howItWorks.titleAccent", "step by step")}</span>
          </h1>
          <p className="text-[color:var(--text-2)] text-sm lg:text-base font-light max-w-2xl">
            {t("howItWorks.subtitle", "OFunded's evaluation is a transparent, simulated trading challenge. Pass the rules, get funded, withdraw up to 90% of your gains. Here's exactly how it works.")}
          </p>
        </div>

        <EvaluationProcess />
        <WhyOFunded />
        <Payouts />

        <RelatedLinks items={HOW_RELATED} />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
